import { BaseMapper } from '@ps/utils';
import { NotificationAction, NotificationItem } from '@ps/notification-models';

import {
  NotificationActionDto,
  NotificationDto,
} from '../dtos/notification.dto';

export class NotificationMapper extends BaseMapper<
  NotificationDto,
  NotificationItem
> {
  public fromDto(notificationDto: NotificationDto): NotificationItem {
    return {
      notificationId: notificationDto.notificationId,
      templateId: notificationDto.templateId,
      type: notificationDto.type,
      sender: {
        kind: notificationDto.sender.kind,
        userId: notificationDto.sender.userId,
        name: notificationDto.sender.name,
      },
      content: notificationDto.content,
      data: notificationDto.data,
      viewed: notificationDto.viewed,
      viewedAt: notificationDto.viewedAt,
      createdAt: notificationDto.createdAt,
      category: notificationDto.category ?? '',
      feature: notificationDto.feature ?? '',
      surface: notificationDto.surface ?? '',
      statusLabel: notificationDto.statusLabel ?? '',
      tags: notificationDto.tags ?? [],
      actionGroupId: notificationDto.actionGroupId ?? null,
      actions: (notificationDto.actions ?? []).map((actionDto) =>
        this._fromActionDto(actionDto),
      ),
    };
  }

  private _fromActionDto(actionDto: NotificationActionDto): NotificationAction {
    return {
      actionId: actionDto.actionId,
      kind: actionDto.kind,
      summaryLabel: actionDto.summaryLabel,
      state: actionDto.state,
      config: actionDto.config ?? {},
      resultLabel: actionDto.resultLabel ?? null,
      appliedBy: actionDto.appliedBy ?? null,
      appliedAt: actionDto.appliedAt ?? null,
    };
  }
}
